module.exports = __webpack_public_path__ + "img/header-engagementRingsCollectionRings@2x.ff4aa9e.jpg";